<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw preface-rw auto-rw page-open-left-rw" epub:type="frontmatter preface" id="preface004">
<h1 class="preface-title"><a href="#/toc#toc-preface004"></a></h1>
<div class="image_full"><img alt="image" src="images/Art_Px.jpg"/></div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface004.vue?117a18cc